export default __webpack_public_path__ + "static/media/not_f.c4cf5081.png";